import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const RouteChangeTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (process.env.REACT_APP_GOOGLE_ANALYTICS) {
      ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS);
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (initialized) {
      ReactGA.set({ page: location.pathname });
      ReactGA.send("pageview");
    }
    
    // 🚀 페이지 전환 커스텀 이벤트 발생 (GlobalTimerContext에서 감지)
    window.dispatchEvent(new CustomEvent('routeChange', {
      detail: { pathname: location.pathname }
    }));
  }, [initialized, location]);

  return null; // Add this line to indicate that the component doesn't render anything
};

export default RouteChangeTracker;
